declare function require(name:string): any;
const MyFontFaceObserver = require('fontfaceobserver');

const defaultFontObserver = new MyFontFaceObserver('proxima-nova') as FontFaceObserver;
defaultFontObserver.load()
	.then(() => {
		window.dispatchEvent(new CustomEvent('fontloaded'));
		window.dispatchEvent(new CustomEvent('heightchange'));
	})
	.catch((err: Error) => {
		console.error('Font failed to load: ', err);
		window.dispatchEvent(new CustomEvent('fontloaded'));
	});
